<template>
  <div class="home">
    <div class="nav">
      <div class="content">
        <img src="../assets/logo.png"
             alt=""
             srcset=""
             class="logo" />

        <div class="right">
          <ul>
            <li :class="{ active: active == 1 }"
                @click="check(1)">首页</li>

            <li :class="{ active: active == 2 }"
                @click="check(2)">核心价值</li>

            <li :class="{ active: active == 3 }"
                @click="check(3)">业务优势</li>

            <li :class="{ active: active == 4 }"
                @click="check(4)">介绍</li>
            <li :class="{ active: active == 5 }"
                @click="check(5)">严正声明</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="banner"
         id="roll-top1">
      <img src="../assets/banner.png"
           alt="" />
    </div>

    <div class="core-value"
         id="roll-top2">
      <div class="content">
        <div class="title">
          <div class="text">核心价值</div>

          <div class="text2">
            凭借多年的技术积累，为客户提供完善、优质的服务！
          </div>
        </div>

        <div class="company-content">
          <div class="item">
            <img src="../assets/icon-exploit.png"
                 alt=""
                 style="margin-bottom: 16px" />

            <div>激情</div>
          </div>

          <div class="item">
            <img src="../assets/icon-test.png"
                 alt=""
                 style="margin-bottom: 16px" />

            <div>责任</div>
          </div>

          <div class="item">
            <img src="../assets/icon-maintenance.png"
                 alt=""
                 style="margin-bottom: 16px" />

            <div>专业</div>
          </div>
          <div class="item">
            <img src="../assets/icon-operate.png"
                 alt=""
                 style="margin-bottom: 16px" />

            <div>创新</div>
          </div>
        </div>
      </div>
    </div>

    <div class="business-advantage"
         id="roll-top3">
      <div class="content">
        <div class="title">
          <div class="text">业务优势</div>

          <div class="text2">完善的服务流程，为客户项目快速上线保驾护航！</div>
        </div>
      </div>
      <div class="serviceflow-option">
        <div class="content">
          <div class="flow-item">
            <p>专业的团队</p>
            <span class="text">专业的团队及系统专业的管理团队、销售团队、风控团队、IT团队、租后团队。系统全自主开发;所有产品和角色在同一系统下操作;资金方系统无缝对接。</span>
          </div>
          <div class="flow-item">
            <p>规范的流程</p>
            <span class="text">规范的流程制度及合同文本所有流程和制度必须符合监管的要求，合规第一。高质量的合同设计，确保风险和漏洞通过合同设计进行相应规避。</span>
          </div>
          <div class="flow-item">
            <p>稳定健康的风控体系</p>
            <span class="text">稳定健康的风控体系及资金方和产品业务全流程风控由公司自行操作，不依赖代理商兜底。资金方丰富，针对每家资方，制定差异化的多款产品。</span>
          </div>
          <div class="flow-item">
            <p>高效的响应机制</p>
            <span class="text">高效的响应机制完善的代理商分级制度，差异化的准入、合作、管理策略。针对市场动向，第一时间响应，不停变革，始终保持自身竞争力。</span>
          </div>
        </div>
        <img src="../assets/serviceflowbg.png"
             alt="" />
      </div>
    </div>

    <div class="introduce"
         id="roll-top4">
      <div class="content">
        <div class="title">
          <div class="text">介绍</div>

          <!-- <div class="text2">经过各种严苛的测试与验证，让系统坚不可摧！</div> -->
        </div>
        <div class="introduce-content">
          辉煌国际融资租赁(天津)有限公司(以下简称“辉煌国际融资租赁”)成立于2016年04月07日，以融资租赁形式开展汽车金融服务，主要发力于新车、二手车和存量车等业务，是依托于互联网技术的新一代融资租赁公司。自创建以来，辉煌国际融资租赁始终着力加强“数字科技+汽车金融”的有效融合，建立起全流程智能化的业务平台，研发了基于阿里云的互联网Saas业务云平台，利用devops体系进行可持续性运维，无间断性部署，通过“微服务”进行模块化管理，灵活高效。同时，辉煌融资租赁基于全流程风险管理理念，结合互联网技术，利用“人工智能+大数据”，建立二十余个“个人信用风险识别系统，优化审批流程，为用户带去全新汽车金融服务体验。
        </div>

       
      </div>
    </div>

    <div class="statement"
         id="roll-top5">
      <div class="content">
        <div class="title">
          <div class="text">严正声明</div>
        </div>
        <div class="introduce-title">致各位尊敬的客户：</div>
        <div class="introduce-content">
          感谢您选择辉煌国际融资租赁（天津）有限公司（以下称“辉煌租赁”），有关您所办理业务的还款方式，辉煌租赁在声明如下：根据您与辉煌租赁签署的《融资租赁合同》、《服务协议》等文件的约定，您的还款方式为第三方支付机构受托划扣。截至本声明发布之日，辉煌租赁合作的第三方支付机构为“宝付支付（全称：宝付网络科技（上海）有限公司）”。 
        </div>
        <div class="introduce-content font-weight-bold">
          下述名单中的第三方机构并非辉煌租赁合作机构，且历史从未有过任何合作。若名单中的第三方机构与您有任何款项往来，均与辉煌租赁无关。为保障您的财产安全，辉煌租赁提醒您：谨慎处理，避免不必要的财产损失。
        </div>
        <div class="introduce-table">
          <table class="table" border="1"> 
            <thead>
              <tr>
                <th colspan="2" align="center">非“辉煌租赁合作机构”名单</th>
              </tr>
              <tr>
                <th align="center">序号</th>
                <th align="center">机构名称</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="center">1</td>
                <td align="center">上海合墨数据科技有限公司</td>
              </tr>
              <tr>
                <td align="center">2</td>
                <td align="center">上海墨小数据科技有限公司</td>
              </tr>
              <tr>
                <td align="center">3</td>
                <td align="center">特约-飞柏彦</td>
              </tr>
               <tr>
                <td align="center">4</td>
                <td align="center">特约新诺贝</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="introduce-right">
          辉煌国际融资租赁（天津）有限公司
        </div>
        <div class="introduce-right">
          2025年7月10日
        </div>
        <div class="introduce-right introduce-pdf" @click="toFile">
          预览相关附件
        </div>
      </div>
    </div>

    <div class="statement"
         id="roll-top5">
      <div class="content">
        <div class="title">
          <div class="text">一次性信用修复政策</div>
        </div>
        <div class="introduce-title font-weight-bold">尊敬的各位客户：</div>
        <div class="introduce-content font-weight-bold">
          【辉煌国际】为响应人民银行一次性信用修复政策，重塑个人信用，若您在 [ 2020年1月1日至2025年12月31日期间，有单笔金额不超过10000元人民币的逾期 ]，请在 [ 2026年3月31日(含) ] 前足额偿还逾期债务,相关逾期记录在征信系统中将不予展示。客服电话： 
        </div>
         <div class="introduce-center font-weight-bold">
          021-37615189
        </div>
         <div class="introduce-center font-weight-bold">
          010-52753460
        </div>
        <div class="introduce-center font-weight-bold">
          0551-62916092
        </div>
        <div class="introduce-center font-weight-bold">
          感谢您对我司的支持，祝您生活愉快!
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="content">
        <div class="left">
          <p>Address</p>

          <span>辉煌国际融资租赁（天津）有限公司</span>

          <span>天津自贸试验区(东疆保税港区)亚洲路6975号金融贸易中心南区1-1-1608</span>
        </div>

        <div class="center">
          <p>Contact us</p>

          <span>如有业务咨询、合作洽谈或意见反馈、征信问题，欢迎随时与我们取得联系。</span>
          <span>客服电话：</span>
          <span>400-168-0570</span>
          <span>021-37615189</span>
          <span>0551-62916092</span>
        </div>

        <div class="right">
          <p>Navigation</p>

          <span>首页</span>

          <span>核心价值</span>

          <span>业务优势</span>

          <span>介绍</span>
        </div>
      </div>

      <div style="text-align: center"
           class="filing">
        <a target="_blank"
           href="http://beian.miit.gov.cn/">
          <span>辉煌国际融资租赁（天津）有限公司 津ICP备2025033779号-2</span>
        </a>
           <!-- href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=2025033779" -->
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=12010402002359" rel="noreferrer" target="_blank">
           <img src="../assets/policeshield.ef881569.png"
               alt="" />
          津公网安备12010402002359号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data () {
    return {
      active: 1,
      pdfSrc: ""
    };
  },
  methods: {
    check (index) {
      this.active = index;
      console.log(document.querySelector(`#roll-top${index}`));
      document.querySelector(`#roll-top${index}`).scrollIntoView({
        behavior: "smooth",
      });
    },
    toFile() {
      this.$router.push({
        path: "/previewPdf",
      });
    },
  },
};
</script>

<style lang="less">
.content {
  width: 1400px;
  height: 100%;
  margin: 0 auto;
  .title {
    text-align: left;
    margin: 0 auto;
    font-size: 28px;
    color: #061332;
    display: flex;
    flex-direction: column;
    .text {
      font-weight: 600;
      font-size: 44px;
      color: #061332;
      text-align: left;
    }
    .text2 {
      font-size: 40px;
      color: #061332;
      text-align: left;
      margin-bottom: 16px;
    }
  }
}
.nav {
  width: 100%;
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(51, 51, 51, 0.16);
  position: fixed;
  top: 0;
  z-index: 10;
  .right {
    ul {
      list-style: none;
      display: flex;
      align-items: center;
      li {
        font-size: 16px;
        color: #333333;
        margin-right: 50px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .active {
        color: #4c8de4;
      }
    }
  }
}
.logo {
  width: 98px;
  height: 26px;
}
.nav .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner {
  width: 100%;
  padding-top: 72px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.core-value {
  padding-top: 75px;
  .content {
    .text2 {
      margin-bottom: 75px;
    }
    .company-content {
      display: flex;
      justify-content: center;
      align-items: center;
      justify-content: space-around;
      margin-top: 16px;
      .item {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-right: 18px;
        font-size: 24px;
        color: #333333;
        font-weight: bold;
        img {
          width: 55px;
          height: 55px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
.business-advantage {
  padding-top: 75px;
  .content {
    .title {
      .text2 {
        margin-bottom: 75px;
      }
    }
  }
  .serviceflow-option {
    width: 100%;
    position: relative;
    .content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      .flow-item {
        width: 262px;
        height: 459px;
        background: #ffffff;
        border-radius: 6px;
        margin-right: 2px;
        padding: 66px 18px 0;
        box-sizing: border-box;
        p {
          font-weight: bold;
          font-size: 22px;
          color: #333333;
          text-align: center;
          margin-bottom: 16px;
        }
        .text {
          display: inline-block;
          font-size: 16px;
          color: #666666;
          // text-indent: 2em;
          line-height: 28px;
        }
        // span {
        //   font-size: 16px;
        //   color: #666666;
        //   text-indent: 2em;
        //   line-height: 28px;
        // }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    img {
      display: block;
      width: 100%;
    }
  }
}
.introduce {
  width: 100%;
  height: 407px;
  background: #edf4fa;
  padding-top: 75px;
  box-sizing: border-box;
  .text2 {
    margin-bottom: 75px;
  }
  .introduce-content {
    font-size: 16px;
    color: #333;
    text-indent: 2em;
    line-height: 28px;
    margin-top: 20px;
  }
}
.statement {
  width: 100%;
  height: 657px;
  background: #edf4fa;
  padding-top: 75px;
  box-sizing: border-box;
  .text2 {
    margin-bottom: 75px;
  }
  .introduce-title {
    font-size: 16px;
    color: #333;
    line-height: 28px;
    margin-top: 20px;
  }
  .introduce-content {
    font-size: 16px;
    color: #333;
    text-indent: 2em;
    line-height: 28px;
    margin-top: 20px;
  }
  .introduce-center { 
    font-size: 16px;
    color: #333;
    text-indent: 2em;
    line-height: 28px;
    margin-top: 8px;
    text-align: center;
  }
  .font-weight-bold {
    font-weight: bold;
  }
  .introduce-table {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    font-size: 16px;
    color: #333;
    .table {
      display: table;
      border-collapse: collapse;
      border-spacing: 0;
      th {
        background: #add0ec;
      }
      th,td {
        padding: 5px 105px;
        // background: #7badee;
      }
    }
  }
  .introduce-right {
    font-size: 16px;
    color: #333;
    text-align: right;
  }
  .introduce-pdf {
    cursor: pointer;
    color: #4c8de4;
    margin-top: 20px;
  }
}
.footer {
  width: 100%;
  min-height: 412px;
  background: #06101e;
  padding-top: 35px;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  .content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    .center,
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    p {
      font-weight: 500;
      font-size: 20px;
      color: #fff;
      margin: 0;
      margin-bottom: 24px;
    }
    span {
      display: inline-block;
      width: 100%;
      font-size: 18px;
      color: #fff;
      margin-bottom: 16px;
    }
    img {
      width: 169px;
      height: 169px;
      margin-bottom: 16px;
    }
    .left {
      flex: 1;
      span {
        &:last-child {
          font-size: 16px;
        }
      }
    }
  }
}
.filing {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    text-decoration: none;
    img {
      margin: 0 1em;
    }
  }
}
</style>
